/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React, { useEffect, useState } from 'react';

import { I18n } from '@aws-amplify/core';
import { Auth } from 'aws-amplify';
import logoTn from '../../assets/Logos/LogoTn.png';
import { Box, Button, FormControl, Input, InputLabel } from '@material-ui/core';
import useStyles from '../../components/LandingPage/signInContainerStyle';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const AccountConfirmationPage = () => {
    const [finalState, setFinalState] = useState();
    const [resendCodeState, setResendCodeState] = useState();

    const [manualCodeState, setManualCodeState] = useState();

    const [loading, setIsLoading] = useState(false);
    const [newCode, setNewCode] = useState();
    const classes = useStyles();

    const getUsername = () => {
        const url = new URL(window.location)
        let queryParams = new URLSearchParams(url.search)
        return queryParams?.get("username")
    }

    useEffect(() => {
        async function handleCode() {
            try {
                setIsLoading(true)
                const url = new URL(window.location)
                let queryParams = new URLSearchParams(url.search)

                const codice = queryParams?.get("codice")
                const username = getUsername()
                console.log("codice ", codice)
                console.log("username ", username)

                const res = await Auth.confirmSignUp(username, codice)
                console.log(res)
                setFinalState("success")

            } catch (error) {
                console.log("ERROR CONFIRM", error)
                setFinalState("error")
            } finally {
                setIsLoading(false)
            }
        }
        handleCode();
    }, [])
    const isError = (finalState === "error" && manualCodeState !== "success")
    const isSuccess = finalState === "success"

    return loading ? (
        <div style={{ backgroundColor: "#287C2D", height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <span className="loaderTn"></span>
        </div>
    ) : (
            <div style={{ padding: 20, maxWidth: 600 }}>
            <img src={logoTn} style={{ maxWidth: 387, objectFit: "contain" }} />
            <h1>
                {isError ? "Si è verificato un errore" : "Complimenti"}
            </h1>
                <h4 >
                    {isError ? "Si prega di ricaricare la pagina o cliccare di nuovo sul link ricevuto per mail." :
                        <div>
                            <p>{"Il tuo account è stato verificato."}</p>
                            <p style={{ fontWeight: 500 }}>{"Ora puoi chiudere la pagina corrente."}</p>
                        </div>}
            </h4>
                {
                    isError ?
                        <div>
                            {
                                (resendCodeState !== "success" && resendCodeState !== "already_confirm") ?

                                    <Button
                                        variant="outlined"
                                        onClick={async () => {
                                            try {
                                                setResendCodeState("")
                                                await Auth.resendSignUp(getUsername())
                                                setResendCodeState("success")
                                            } catch (error) {
                                                console.log("e", error?.message)
                                                setResendCodeState(error?.message?.includes("User is already confirmed") ? "already_confirm" : "error")
                                            }
                                        }}
                                    >
                                        {"Invia una nuova mail di verifica account"}
                                    </Button>
                                    : null
                            }
                            <p style={{
                                color: resendCodeState === "error" ? "red" : "#287C2D"
                            }}>{resendCodeState === "error" ? "Si è verificato un errore durante la richiesta di reinvio mail, si prega di contattare l'assistenza" :
                                (resendCodeState === "success" && manualCodeState !== "success") ? "Mail inviata con successo, inserisci di seguito il nuovo codice di verifica" :
                                    resendCodeState === "already_confirm" ? "Il tuo account è già stato verificato" : ""}</p>
                            {
                                resendCodeState === "success" &&

                                <div>
                                    {
                                        manualCodeState !== "success" &&

                                        <Box style={{ flexDirection: "column", display: "flex" }}>
                                            <FormControl className={classes.formControl}>
                                                <InputLabel htmlFor="codice">
                                                    {"Codice di verifica"}
                                                </InputLabel>
                                                <Input
                                                    value={newCode}
                                                    type={'text'}
                                                    className={classes.textField}
                                                    onChange={(event) => setNewCode(event.target.value)}
                                                    id="codice"
                                                    inputProps={{ style: { left: 0, borderColor: "#287C2D" } }}
                                                />
                                            </FormControl>

                                            <Button
                                                variant="contained"
                                                type="button"
                                                style={{ marginTop: 25 }}
                                                onClick={async () => {
                                                    try {
                                                        setManualCodeState("")
                                                        await Auth.confirmSignUp(getUsername(), newCode)
                                                        setManualCodeState("success")
                                                    } catch (error) {
                                                        setManualCodeState("error")
                                                    }
                                                }}
                                            >
                                                {"Conferma account"}
                                            </Button>
                                        </Box>
                                    }
                                    <p style={{
                                        color: manualCodeState === "error" ? "red" : "#287C2D"
                                    }}>{manualCodeState === "error" ? "Il codice inserito non è valido, verifica che corrisponda al codice ricevuto via mail altrimenti ricarica la pagina e richiedi un nuovo codice." :
                                        manualCodeState === "success" ? "Complimenti, il tuo account è stato verificato." : ""}</p>
                                </div>
                            }
                        </div>
                        : null
                }

                {
                    isSuccess || resendCodeState === "done" &&
                    <p>{"Ora puoi chiudere questa finestra"}</p>
                }
                <div style={{marginTop:30, display:"flex", alignItems:"center"}}>
                    <a style={{display:"block",  marginLeft:2, fontSize:15}} href='https://tecnichenuove.com'>{"Vai allo store di tecniche nuove"}</a>
                </div>
        </div>
    )
}

export default AccountConfirmationPage;
